// components/modals/SessionWarningModal.js - React modal for session warnings
import React, { memo } from 'react';
import PropTypes from 'prop-types';

const SessionWarningModal = ({ isOpen, minutesRemaining, onExtend, onLogout }) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '8px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
        textAlign: 'center',
        maxWidth: '400px',
        margin: '20px'
      }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '20px',
          color: '#ff9800'
        }}>
          ⏰
        </div>
        
        <h2 style={{
          color: '#333',
          marginBottom: '16px',
          fontSize: '20px',
          fontWeight: 'bold'
        }}>
          Session Expiring Soon
        </h2>
        
        <p style={{
          color: '#666',
          fontSize: '16px',
          lineHeight: '1.5',
          marginBottom: '25px'
        }}>
          Your session will expire in <strong>{minutesRemaining} minute{minutesRemaining !== 1 ? 's' : ''}</strong> due to inactivity.
        </p>
        
        <div style={{
          display: 'flex',
          gap: '10px',
          justifyContent: 'center'
        }}>
          <button
            onClick={onExtend}
            style={{
              backgroundColor: '#9404C3',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#7a0399'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#9404C3'}
          >
            Continue Session
          </button>
          
          <button
            onClick={onLogout}
            style={{
              backgroundColor: '#f5f5f5',
              color: '#666',
              border: '1px solid #ddd',
              padding: '12px 24px',
              borderRadius: '6px',
              fontSize: '16px',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#e9e9e9'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#f5f5f5'}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

SessionWarningModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  minutesRemaining: PropTypes.number.isRequired,
  onExtend: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired
};

const arePropsEqual = (prevProps, nextProps) => {
  return (
    prevProps.isOpen === nextProps.isOpen &&
    prevProps.minutesRemaining === nextProps.minutesRemaining &&
    prevProps.onExtend === nextProps.onExtend &&
    prevProps.onLogout === nextProps.onLogout
  );
};

SessionWarningModal.displayName = 'SessionWarningModal';

export default memo(SessionWarningModal, arePropsEqual);